import ReactModal from 'react-modal';

import {
  DecisionModalIcon,
  DecisionModalIconType,
} from '../../../Signup/components/DecisionModal/DecisionModalIcon';
import { DecisionPollingStatus } from '../../hooks/useDecisionPolling';

export const PayLaterDecisionModal = ({
  status,
}: {
  status: DecisionPollingStatus;
}) => {
  if (status === 'idle') return null;

  return (
    <ReactModal
      className="absolute left-1/2 top-1/2 flex min-h-[288px] w-full max-w-[301px] -translate-x-1/2 -translate-y-1/2 flex-col rounded-s border border-secondary-80 bg-white p-l shadow-black-m outline-none"
      overlayClassName="fixed z-[15] inset-0 bg-overlay-decision-modal"
      isOpen
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <ModalContent status={status} />
    </ReactModal>
  );
};

const ModalContent = ({ status }: { status: DecisionPollingStatus }) => {
  if (status === 'approved') {
    return (
      <>
        <DecisionModalIcon type={DecisionModalIconType.APPROVAL} />
        <p className="mb-l text-center text-xl font-bold text-success-drk">
          Approved
        </p>
        <p className="mb-l text-center text-m font-reg text-structure-40">
          Redirecting to checkout...
        </p>
      </>
    );
  }

  if (status === 'declined') {
    return (
      <>
        <div className="flex flex-1 items-center text-center text-xl font-bold">
          Sorry, we can&apos;t fund your application at this time
        </div>
        <p className="mb-l text-center text-m font-reg text-structure-40">
          Redirecting to your dashboard...
        </p>
      </>
    );
  }

  if (
    status === 'partial' ||
    status === 'blocked' ||
    status === 'timeout' ||
    status === 'error'
  ) {
    return (
      <>
        <DecisionModalIcon type={DecisionModalIconType.LOADING} />
        <div className="flex grow items-center justify-center">
          <p className="mb-l text-center text-m font-reg text-structure-40">
            Redirecting to your dashboard...
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <DecisionModalIcon type={DecisionModalIconType.LOADING} />
      <div className="flex grow items-center justify-center">
        <p className="mb-l text-center text-m font-reg text-structure-40">
          Please wait while we process your application
        </p>
      </div>
    </>
  );
};
